import api from '../../../App/socket';

export const createBikeModel = params => (
    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Create',
        options: {
            create: params,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/requests/create_bike_model_request.js